export enum ApplyFeesState {
  route = "route",
  addFees = "addFees",
  getBreakdown = "getBreakdown",
  error = "error",
}
